import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import Button from '../button/Button';
import { H1 } from '../containers/Headers';
import Spinner from '../spinner/Spinner';
import Input from '../formInputs/Input';
import EmailSent from '../../migrate/recovery/EmailSent';
import ImportAccountModal from '../../user/importAccountModal/ImportAccountModal';

import { recoverUsername, setValidationError } from '../../migrate/actions';
import { validationError } from '../../migrate/reducer';

import { required, email } from '~APP_UTIL/formValidations';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

class UsernameRecover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailSent: false
    };
  }

  componentDidMount() {
    const { validationError, setValidationError } = this.props;
    if (validationError !== '') {
      setValidationError('');
    }
  }

  setEmailSent = bool => this.setState({ emailSent: bool });

  handleSubmit = () => {
    const {
      usernameRecoverForm: { values },
      recoverUsername,
      history,
      isModal
    } = this.props;

    return recoverUsername({ email: values.recoveryEmail }).then(({ payload }) => {
      if (payload && payload.message === 'success') {
        this.setEmailSent(true);
        if (!isModal) {
          history.push('/legacy/username/sent');
        }
      }
    });
  };

  render() {
    const { usernameRecoverForm, submitting, handleSubmit, validationError, isModal } = this.props;
    const { emailSent } = this.state;
    return (
      <div className='ta-sm-c'>
        {!emailSent && (
          <form onSubmit={handleSubmit(() => this.handleSubmit())} className='ta-sm-c' style={{ maxWidth: '338px' }}>
            <H1 className='mt6-sm'>
              <TranslatedCopy id='migrate.user.recoverUser.title' />
            </H1>
            <p className='body-4 pt3-sm pb7-sm'>
              <TranslatedCopy id='migrate.user.recoverUser.body' />
            </p>

            <Field
              name='recoveryEmail'
              type='text'
              component={Input}
              label='Email Address'
              validate={[required, email]}
              placeholder='Please enter your email address'
              autoComplete='email'
            />
            <div className='flex-container center mt3-sm'>
              <Button
                type='submit'
                disabled={usernameRecoverForm && usernameRecoverForm.syncErrors}
                extraClassName='responsive-display-2-1 pt2-sm pr5-sm pb2-sm pl5-sm ncss-btn-dark-grey u-full-width'
                color='border-grey'
                data-desc='usernameRecovery__form-submit'
              >
                {submitting ? <Spinner className='relative-container p3-sm' /> : <TranslatedCopy id='global.submit' />}
              </Button>

              {validationError && <div className='text-color-error pt3-sm'>{validationError}</div>}
            </div>
          </form>
        )}
        {emailSent && (
          <div className='pt4-sm'>
            <EmailSent isModal />
          </div>
        )}
        {isModal && (
          <div className='pt4-sm'>
            <ImportAccountModal />
          </div>
        )}
      </div>
    );
  }
}

UsernameRecover.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history,
  isModal: PropTypes.bool,
  recoverUsername: PropTypes.func.isRequired,
  setValidationError: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  usernameRecoverForm: PropTypes.any,
  validationError: PropTypes.string.isRequired
};

UsernameRecover.defaultProps = { history: null, isModal: false, usernameRecoverForm: null };

const mapStateToProps = state => ({
  usernameRecoverForm: state.form.UsernameRecover,
  validationError: validationError(state)
});

const connector = connect(mapStateToProps, {
  recoverUsername,
  setValidationError
});

export default reduxForm({
  form: 'UsernameRecover'
})(connector(UsernameRecover));
